import React, {useEffect} from "react";
import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
    User,
    Chip,
    Link,
    Tooltip,
    getKeyValue, Button, ButtonGroup, Spinner, Modal, ModalContent, ModalBody, ModalHeader, ModalFooter, Pagination
} from "@nextui-org/react";
import {FaEdit, FaUndo} from 'react-icons/fa'
import {getDetailsTransactions, getTransactions, rollbackTransaction, setStatusTransaction} from "../API";
import {useNavigate} from "react-router-dom";
import {toast, Toaster} from "sonner";
import TransactionsDetails from "./TransactionDetails";

const statusMap = {
    "AP": "success",
    "RO": "danger",
    "RE": "danger",
    "PE": "warning",
};

export default function Transactions() {

    const navigate = useNavigate();
    const [transactions, setTransactions] = React.useState([]);
    const [details, setDetails] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isOpen, setIsOpen] = React.useState(false);
    const columns = [
        {name: "ID", uid: "idtransaction"},
        {name: "HOOK_ALIAS (BANCARD)", uid: "bancard_idtransaction"},
        {name: "FECHA", uid: "created_at"},
        {name: "PAGADO", uid: "status_paid"},
        {name: "EXPENDIO", uid: "status_expense"},
        {name: "REPOSICIONADO", uid: "status_reposition"},
        {name: "ULT. ACTUALIZACION", uid: "date_update"},
        {name: "ACCIONES", uid: "actions"},
    ];

    const [page, setPage] = React.useState(1);
    const rowsPerPage = 25;

    const pages = Math.ceil(transactions.length / rowsPerPage);

    const items = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;

        return transactions.slice(start, end);
    }, [page, transactions]);

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        const m = await getTransactions();
        setIsLoading(false);
        setTransactions(m);
    }

    async function Details(idtransaction) {
        const data = await getDetailsTransactions(idtransaction);
        if(data){
            setIsOpen(true);
            setDetails(data);
        }else
            toast.error("Sin detalles en la transaccion");
    }

    async function ChangeStatus(idtransaction, status, type) {

        const selectedKey = status === "PE" ? 'AP' : 'PE';
        const res = await setStatusTransaction(idtransaction, selectedKey, type);

        if (res === 200) {
            setTransactions(prevTransactions =>
                prevTransactions.map(transaction =>
                    transaction.idtransaction === idtransaction
                        ? {...transaction, [type === "EXPE" ? "status_expense" : "status_reposition"]: selectedKey}
                        : transaction
                )
            );
            toast.success("Estado actualizado.");
        } else
            toast.error("No se pudo actualizar.");
    }


    async function Rollback(hook_alias) {
        const data = await rollbackTransaction(hook_alias);
        if (data.status === 'success') {
            toast.success("Transaccion revertida correctamente");
        } else
            toast.error("La reversion ya no es posible");
    }

    const renderCell = React.useCallback((transaction, columnKey) => {
        const cellValue = transaction[columnKey];
        switch (columnKey) {

            case 'bancard_idtransaction':
                return (<b className="text-warning hover:cursor-pointer"
                           onClick={() => Details(transaction.idtransaction)}>{cellValue}</b>);

            case "actions":
                return (
                    <div className="relative flex items-center gap-2">
                        <Button onPress={() => Rollback(transaction.bancard_idtransaction)} color="transparent"
                                isIconOnly>
                            <Tooltip content="Rollback">
                                  <span className="text-lg text-danger cursor-pointer active:opacity-50">
                                    <FaUndo/>
                                  </span>
                            </Tooltip>
                        </Button>
                    </div>
                )
                    ;

            case 'status_paid':
                return (
                    <Chip color={statusMap[cellValue]}>{cellValue}</Chip>
                );

            case 'status_expense':
                return (
                    <Chip className={cellValue != "RO" || cellValue != "RE" ? "hover:cursor-pointer" : null}
                          color={statusMap[cellValue]}
                          onClick={() => ChangeStatus(transaction.idtransaction, cellValue, 'EXPE')}>{cellValue}</Chip>
                );

            case 'status_reposition':
                return (
                    <Chip className={cellValue != "RO" || cellValue != "RE" ? "hover:cursor-pointer" : null}
                          color={statusMap[cellValue]}
                          onClick={() => ChangeStatus(transaction.idtransaction, cellValue, 'REPO')}>{cellValue}</Chip>
                );

            case 'created_at':
            case 'date_update':
                if (!cellValue) return '';
                const date = cellValue.split("T")[0];
                const hour = cellValue.split("T")[1];
                return `${date} ${hour}`;

            default:
                return cellValue;
        }
    }, []);

    if (isLoading) return <div className="text-center"><Spinner color="warning" size="lg"/></div>

    return (
        <>
            <Toaster richColors/>
            <div className="container flex flex-col">
                <h1 className="text-center pb-2 text-2xl">Transacciones</h1>

                <Table aria-label="Maquinas" selectionMode="single"
                       bottomContent={
                           <div className="flex w-full justify-center">
                               <Pagination
                                   isCompact
                                   showControls
                                   showShadow
                                   color="warning"
                                   page={page}
                                   total={pages}
                                   onChange={(page) => setPage(page)}
                               />
                           </div>
                       }
                       classNames={{
                           wrapper: "min-h-[222px]",
                       }}
                >
                    <TableHeader columns={columns}>
                        {(column) => (
                            <TableColumn key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
                                {column.name}
                            </TableColumn>
                        )}
                    </TableHeader>
                    <TableBody items={items}>
                        {(item) => (
                            <TableRow key={item.idtransaction}>
                                {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>

                <Modal isOpen={isOpen} size="xl" onClose={() => setIsOpen(false)}>
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">Detalles de la transaccion</ModalHeader>
                                <ModalBody>
                                    <TransactionsDetails details={details}/>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="light" onPress={onClose}>
                                        Cerrar
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        </>


    )
        ;
}
